module.exports = __webpack_public_path__ + "img/duomai_logo.729ccb32.png";